import { useCallback, useContext } from "react";

import { RealtimeContext } from "domains/realtime/components/RealtimeContext";
import { useHubClientTransport } from "domains/realtime/hooks/useHubClientTransport";
import { useNativeSignalRTransport } from "domains/realtime/hooks/useNativeSignalRTransport";
import { useCanUseSignalRViaNativeBridge } from "domains/realtime/hooks/utils/useCanUseSignalRViaNativeBridge";
import { Transport } from "domains/realtime/types";

export const useTransport = (): Transport => {
    const { hubClient, updateMeta } = useContext(RealtimeContext);

    const updateMetaLastUpdatedMessage = useCallback(() => {
        updateMeta?.({ lastReceivedMessage: Date.now() });
    }, [updateMeta]);

    const nativeTransport = useNativeSignalRTransport(
        updateMetaLastUpdatedMessage,
    );
    const hubClientTransport = useHubClientTransport(
        hubClient,
        updateMetaLastUpdatedMessage,
    );

    const canUseSignalRViaNativeBridge = useCanUseSignalRViaNativeBridge();

    return canUseSignalRViaNativeBridge ? nativeTransport : hubClientTransport;
};
